const getCleanValue = (value?: string): string | number => {
  const MAX_LENGTH = 7;
  if (!value || +value < 0) return '';

  // Since 0001 is a valid number.
  if (value.length > 1 && value[0] === '0') {
    return '';
  }

  return +value.slice(0, MAX_LENGTH);
};

interface SliderValue {
  max: number | string;
  min: number | string;
}

interface InputChangeProps {
  inputChange: (props: SliderValue) => void;
}

interface ForceValueProps extends SliderValue, InputChangeProps {}

interface ForceMinValueProps extends ForceValueProps {
  minValue: number;
}

interface ForceMaxValueProps extends ForceValueProps {
  maxValue: number;
}

export const forceMinValue =
  ({ inputChange, max, min, minValue }: ForceMinValueProps) =>
  () => {
    if (!min || Number(min) < minValue) {
      inputChange({ min: minValue, max });
    }

    if (min > max) {
      inputChange({ min: min >= max ? +max - 1 : min, max });
    }
  };

export const forceMaxValue =
  ({ inputChange, max, min, maxValue }: ForceMaxValueProps) =>
  () => {
    if (!max || Number(max) > maxValue) {
      inputChange({ max: maxValue, min });
    }

    if (max < min) {
      inputChange({ max: min, min });
    }
  };

interface SetValueProps extends InputChangeProps {
  min?: number | string;
  max?: number | string;
}

export const setValue =
  ({ inputChange, min, max }: SetValueProps) =>
  (_: unknown, value?: string): void => {
    const cleanValue = getCleanValue(value);

    if (min !== undefined) {
      inputChange({ max: cleanValue, min });
    }

    if (max !== undefined) {
      inputChange({ min: cleanValue, max });
    }
  };
